import Experience from "../Experience";

// Named ranges over the baked 361-frame timeline. Structural (fixed by the
// AE export), not data-driven — matches the reference's CLIPS constant.
const CLIPS = [
  { id: "sky", from: 0, to: 140 },
  { id: "dolly", from: 141, to: 257 },
  { id: "explode", from: 258, to: 360 },
];

export default class SceneData {
  constructor() {
    this.experience = new Experience();

    this.clips = CLIPS;
    this.scene = null;
    this.preset = null;
  }

  async load() {
    const [sceneRes, presetRes] = await Promise.all([
      fetch("/hyundai-tco/scene.json"),
      fetch("/hyundai-tco/preset.json"),
    ]);

    this.scene = await sceneRes.json();
    this.preset = await presetRes.json();
  }

  getLayer(name) {
    return this.scene.layers.find((layer) => layer.name === name) ?? null;
  }

  // Which clip a timeline frame falls in, clamped to the first/last clip at
  // either end of the range.
  getClipAt(frame) {
    for (const clip of this.clips) {
      if (frame >= clip.from && frame <= clip.to) return clip;
    }
    return frame < this.clips[0].from
      ? this.clips[0]
      : this.clips[this.clips.length - 1];
  }
}
